module.exports = __webpack_public_path__ + "img/test-drive-suburban.123369a9.svg";